import { IValidation } from 'src/types/main';
import { SORTING_DIRECTION } from '~/constants/main';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { crmRestrictionDTO } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/dto';

export interface IRestriction {
  customer: IPickerOption[];
  payment_type: number;
  comment?: string;
}

export interface ICustomerRestriction {
  id: number;
  customer: ICustomer;
  mobile: string;
  payment_type: number;
  comment: string;
  disabled_by: IDisabledBy;
  disabled_at: string;
}

export interface ICustomer {
  id: number;
  first_name: string;
  last_name: string;
  mobile: string;
}

export interface IDisabledBy {
  id: number;
  first_name: string;
  last_name: string;
}

export interface ISearchCustomer {
  id: number;
  name: string;
}

export type TCustomerRestrictionValidation = {
  customer: IValidation;
  payment_type: IValidation;
};

export interface ICustomerRestrictionsFilters {
  search: string;
}

export interface ICustomerRestrictionsSorting {
  sortField?: CRM_RESTRICTIONS_COLUMNS;
  sortDir?: SORTING_DIRECTION;
}

export enum CRM_RESTRICTIONS_COLUMNS {
  PHONE = 'PHONE',
  DISABLED_AT = 'DISABLED_AT',
}

export const sortFieldsMap = {
  [CRM_RESTRICTIONS_COLUMNS.PHONE]: 'mobile',
  [CRM_RESTRICTIONS_COLUMNS.DISABLED_AT]: 'disabled_at',
};

export type CrmRestrictionsResponse = {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  from: number;
  to: number;
  data: ICustomerRestriction[];
};

export type TCrmRestrictionsItem = ReturnType<typeof crmRestrictionDTO>;
